import { render, staticRenderFns } from "./TaxFormModal.vue?vue&type=template&id=321bdd72&scoped=true&"
import script from "./TaxFormModal.vue?vue&type=script&lang=js&"
export * from "./TaxFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321bdd72",
  null
  
)

export default component.exports